<template>
  <div style="position: relative; transition: 0.3s ease-in-out;"
       :style="{ opacity: inSelection ? selected ? 1 : 0.5 : 1}"
  >
    <v-progress-circular
        style="position: absolute; transform: scale(1.2); z-index: 10"
        :size="profilePicWidth"
        color="primary"
        :value="progression"
        v-if="selected"
    ></v-progress-circular>
    <v-progress-circular
        style="position: absolute; transform: scale(1.2)"
        :size="profilePicWidth"
        color="#256797"
        :value="100"
        v-if="selected"
    ></v-progress-circular>
    <v-progress-circular
        style="position: absolute; transform: scale(1.21)"
        color="white"
        :width="1"
        :size="profilePicWidth"
        :value="100"
        v-if="selected"
    ></v-progress-circular>
    <v-img
        class="elevation-10"
        style="border: 1px solid white; border-radius: 50%"
        :width="profilePicWidth"
        :height="profilePicHeight"
        :src="candidate.avatar"
        v-if="candidate && candidate.avatar"
    >
      <template #placeholder>
        <v-row no-gutters justify="center" align="center" class="fill-height">
          <v-col cols="auto">
            <v-progress-circular
                indeterminate
                color="rgba(255, 255, 255, 0.3)"
                :width="5"
                :size="70"
            ></v-progress-circular>
          </v-col>
        </v-row>
      </template>
    </v-img>
    <div v-else
         class="elevation-10"
         style="border: 1px solid white; display: flex; justify-content: center; align-items: center; flex-direction: column; border-radius: 100%; background-color: #2A72A1"
         :style="{ 'width': profilePicWidth + 'px', 'height': profilePicHeight + 'px' }"
    >
      <span class="white--text" :style="{ fontSize: profilePicHeight / 4 + 'px' }">
        {{ initials }}
      </span>
    </div>
    <v-row
        no-gutters
        style="position: absolute; width: 100%;"
        justify="center"
        :style="{ top: (profilePicHeight - 32) + 'px' }"
    >
      <v-fade-transition>
        <v-col
            cols="auto"
            style="border-radius: 50%; background-color: #2196F3; width: 55px; height: 55px;"
            v-if="wasSelected"
        >
          <div class="fill-height pa-1" style="width: 100%;">
            <v-icon color="white" :size="48">mdi-check</v-icon>
          </div>
        </v-col>
      </v-fade-transition>
    </v-row>
    <div class="text-center mt-7 white--text"
         :style="{ maxWidth: profilePicWidth + 'px' }"
         v-if="!hideNames"
    >{{ candidate.name }}
    </div>
  </div>
</template>
<script>
export default {
  name: "CandidateAvatar",
  props: {
    candidate: {
      type: Object
    },
    profilePicHeight: {
      type: Number
    },
    profilePicWidth: {
      type: Number
    },
    hideNames: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    wasSelected: {
      type: Boolean,
      default: false,
    },
    inSelection: {
      type: Boolean,
      default: false,
    },
    progression: {
      type: Number,
      default: 0,
    }
  },
  computed: {
    initials() {
      let initials = this.candidate.name.match(/\b\w/g) || [];
      return ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
    },
  },
  mounted() {
  }
}
</script>

<style scoped>

</style>